import React from 'react';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import findStringThroughChildren from 'helpers/findStringThroughChildren';

const TooltipWrapper = ({
  condition,
  children,
  tooltipContent,
}: any): JSX.Element =>
  findStringThroughChildren(children).match(/other/i) ? (
    <TippyToolTip
      enabled
      tooltipContent={`‘Other’ represents everything that's reported on a country that's not in
          the country filter dropdown list (where we don’t have an office or presence
          in, typically, areas where we license distribution to 3rd parties).`}
      withDashedLine
      maxWidth="460px"
    >
      {children}
    </TippyToolTip>
  ) : condition ? (
    <TippyToolTip
      enabled={condition}
      tooltipContent={tooltipContent}
      maxWidth="170px"
    >
      {children}
    </TippyToolTip>
  ) : (
    children
  );

export default TooltipWrapper;
